import { ReactNode } from 'react';

import { Typography } from '@mui/material';

interface PedidoProdutoModalInfoTitulo {
    children: ReactNode;
    bold?: boolean;
}

export function PedidoProdutoModalInfoTitulo({ children, bold }: PedidoProdutoModalInfoTitulo) {
    return (
        <Typography
            sx={{
                fontSize: '.8rem',
                lineHeight: '1.3em',
                fontWeight: bold ? 600 : undefined,
                pb: 1,
                mb: 0.5,
                borderBottom: (theme) => `1px solid ${theme.alpha(theme.palette.common.black, 0.12)}`,

                span: {
                    fontSize: '1rem',
                    display: 'block',
                },
            }}
        >
            {children}
        </Typography>
    );
}
